// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PeUo","clinicsSelect":"styles_clinicsSelect__18Pxd"};